const styles = theme => ({
  containerWrapperEquipGroupList: {
    display: 'flex',
    width: '100%',
    flexDirection: 'column',
  },
  containerEquipGroup: {
    display: 'flex',
    width: '100%',
    backgroundColor: theme.palette.gray[10],
    minHeight: '80px',
    alignItems: 'center',
    borderRadius: '0 8px 8px 0',
    borderBottom: `1px solid ${theme.palette.gray[20]}`,
    borderRight: `1px solid ${theme.palette.gray[20]}`,
  },
  firstGroup: {
    borderTop: `1px solid ${theme.palette.gray[20]}`,
  },
  wrapperEquipGroupStatus: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'stretch',
  },
  wrapperLabelGroup: {
    width: '34px',
    height: '73px',
    display: 'flex',
    overflow: 'hidden',
    flexShrink: 0,
    alignItems: 'center',
    justifyContent: 'center',
  },
  boxLabelGroup: {
    backgroundColor: theme.palette.gray[40],
    borderRadius: '8px',
    alignItems: 'center',
    justifyContent: 'center',
    display: 'flex',
    // width: "auto",
    transform: 'rotate(-90deg)',
    transformOrigin: 'center',
    width: '72px',
  },
  labelGroup: {
    fontWeight: 500,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: 'block',
    fontSize: '10px',
    lineHeight: '20px',
    padding: '1px 6px',
    maxWidth: '72px',
    minWidth: '40px',
    textAlign: 'center',
    color: theme.palette.common.white,
    cursor: 'default',
  },
  boxEquipItem: {
    display: 'flex',
    gap: '4px',
    padding: '15px 2px',
    flexWrap: 'wrap',
    borderRadius: '8px',
  },
});

export default styles;
